<div mat-dialog-title>
  <span class="text-xl font-bold">
    {{ title }}
  </span>
</div>

<mat-dialog-content class="mat-typography">
  <div class="flex flex-col w-full h-full gap-4 overflow-hidden">
    <div class="flex w-full gap-4 h-1/6">
      <div class="w-1/2">
        <mat-form-field class="w-full mt-4">
          <mat-label
          >{{ 'raw-data.fields.' + columnName | transloco }}
          </mat-label>
          <input
            matInput
            type="number"
            [formControl]="cellFormControl"
            (input)="onInput()"
          />
          <button
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="onClearButtonClick()"
            [disabled]="!cellFormControl.value"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="w-1/2 mt-4">
        <dx-date-box
          type="datetime"
          [formControl]="timestampFormControl"
          placeholder="{{ 'raw-data.filters.PRODUCT_DATE' | transloco }}"
          [inputAttr]="{
            'aria-label': 'raw-data.filters.PRODUCT_DATE' | transloco,
          }"
        >
        </dx-date-box>
      </div>
    </div>
    <div class="w-full overflow-auto h-4/6">
      <feature-pivot-table-cell-history></feature-pivot-table-cell-history>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end space-x-2">
  <cc-delete-action-button (onClick)="deleteCell()"></cc-delete-action-button>
  <cc-cancel-action-button [mat-dialog-close]="true"></cc-cancel-action-button>
  <cc-save-action-button
    (onClick)="updateCell()"
    [disabled]="!cellFormControl.valid || isButtonDisabled"
  ></cc-save-action-button>
</mat-dialog-actions>
